import OpenTradeLinkPanel from './OpenTradeLinkPanel';

export default OpenTradeLinkPanel;
